import React from 'react';
import { TableCell, TableRow} from '@mui/material';
import { Link } from 'react-router-dom';
import { useState } from 'react';

const RMreadonlyrow = ({k,onChangeSub, row,onClickAddSubCateg, onClickEdit,handleDeleteClick,
   page, rowsPerPage, editCategory}) =>{
    console.log(row)
    
    return(        
        <>
         <TableRow key={k} name={row.categ}>
            <TableCell component="th" scope="row">
            {(page)*(rowsPerPage)+k+1}
            </TableCell>
         <TableCell  align="left">
          {row?.Category}
         </TableCell>
        <TableCell  align="left">
          {editCategory === null?
            <select onChange={(e)=>onChangeSub(e,k)}>
              <option>Select</option>
              {row?.Subject? row?.Subject.map((item,key)=> <option key={key}>{item}</option>):null}
            </select>: "Select"}          
            </TableCell>
      
            <TableCell align="left">
              <button style={{marginRight:'10px'}} type="button"
                onClick ={(e)=>onClickEdit(e,k,row)}>Edit
              </button>
              <button style={{marginRight:'10px'}} type="button"
                onClick ={(e)=>handleDeleteClick(e,k, row.id)}>Delete
              </button>
              {/* <Link to={"subcateg"}> */}
              <button
                style={{marginRight:'10px'}} type="button" 
                onClick={(e)=>onClickAddSubCateg(e,k)}>Add Subject</button>
              {/* </Link> */}                           
            </TableCell>
          </TableRow>     
        </>        
    )
}

export default RMreadonlyrow;